import { Mapper } from "../../../../base/utils/mapper";
import { FiscalResponsibilityModel } from "../../../../domain/models/configuration/fiscal-responsibility.usecase";
import { FiscalResponsibilityEntity } from "../entities/fiscal-responsability.entity";


export class FiscalResponsibilityImplementationRepositoryMapper extends Mapper<FiscalResponsibilityEntity, FiscalResponsibilityModel> {
	mapFrom(param: FiscalResponsibilityEntity): FiscalResponsibilityModel {
		return {
			data:param.data,
			isSuccess:param.isSuccess,
			message:param.message,
			errors:param.errors
		};
	}
	mapTo(param: FiscalResponsibilityModel): FiscalResponsibilityEntity {
		return {
			data:param.data,
			isSuccess:param.isSuccess,
			message:param.message,
			errors:param.errors
		}
	}
}